<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- لوحة التحكم -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-body d-flex justify-content-between align-items-center">
        <div>
          <h4 class="fw-bold text-primary mb-1">
            <i class="fas fa-chart-bar ms-2"></i> الإحصاء التفصيلي للجان
          </h4>
          <span class="text-muted small">شاملاً (المنازل - الدمج - الجنسيات - الديانة)</span>
        </div>
        <div>
            <button @click="fetchData" class="btn btn-outline-primary ms-2">
                <i class="fas fa-sync-alt" :class="{'fa-spin': loading}"></i> تحديث
            </button>
            <button @click="printPage" class="btn btn-dark px-4 fw-bold">
                <i class="fas fa-print ms-2"></i> طباعة
            </button>
        </div>
      </div>
    </div>

    <!-- منطقة الطباعة -->
    <div id="printMe" v-if="committees.length > 0">
      
      <div class="report-header text-center d-none d-print-block mb-4 border-bottom pb-2">
         <h3 class="fw-bold">بيان إحصائي بتشكيل اللجان (عام / منازل / دمج)</h3>
         <h5 class="fw-bold">الشهادة الإعدادية - للعام الدراسي 2026</h5>
      </div>

      <div v-for="committee in committees" :key="committee.id" class="committee-block mb-5">
        
        <!-- عنوان اللجنة -->
        <div class="committee-header bg-dark text-white p-2 d-flex justify-content-between align-items-center rounded-top print-header-bg">
            <div class="d-flex align-items-center">
                <span class="badge bg-warning text-dark fs-5 me-2 ms-2">{{ committee.id }}</span>
                <h5 class="m-0 fw-bold">لجنة: {{ committee.commitee_name }}</h5>
            </div>
            <div class="fw-bold text-light opacity-75 ms-3">
                الإدارة: {{ committee.administration_name || 'عام' }}
            </div>
        </div>

        <!-- الجدول -->
        <div class="table-responsive">
            <table class="table table-bordered border-dark text-center align-middle mb-0 custom-table">
                <thead class="bg-light">
                    <tr>
                        <th rowspan="2" width="5%">م</th>
                        <th rowspan="2" width="30%">المدرسة</th> <!-- تم تقليل العرض قليلاً لاستيعاب المنازل -->
                        <th rowspan="2" width="8%">الإجمالي</th>
                        
                        <!-- إضافة المنازل هنا -->
                        <th rowspan="2" width="8%" class="bg-secondary text-white print-grey">منازل</th>
                        
                        <th colspan="2" width="18%">الديانة</th>
                        <th colspan="2" width="18%">الجنسية</th>
                        <th rowspan="2" width="8%">دمج</th>
                    </tr>
                    <tr>
                        <th class="small-th">مسلم</th>
                        <th class="small-th">مسيحي</th>
                        <th class="small-th">مصري</th>
                        <th class="small-th">وافد</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(school, index) in committee.schools" :key="school.id">
                        <td>{{ index + 1 }}</td>
                        <td class="text-start pe-2 fw-bold text-truncate" style="max-width: 250px;">{{ school.school_name }}</td>
                        
                        <!-- الإجمالي -->
                        <td class="fw-bold bg-light">{{ school.total_count }}</td>
                        
                        <!-- المنازل -->
                        <td class="fw-bold">
                            <span v-if="school.manazel_count > 0" class="badge bg-secondary text-white print-badge">
                                {{ school.manazel_count }}
                            </span>
                            <span v-else class="text-muted">-</span>
                        </td>
                        
                        <td>{{ school.muslim_count }}</td>
                        <td>
                            <span v-if="school.christian_count > 0">{{ school.christian_count }}</span>
                            <span v-else class="text-muted">-</span>
                        </td>
                        
                        <td>{{ school.egyptian_count }}</td>
                        <td>
                            <span v-if="school.palestinian_count > 0" class="badge bg-danger text-white print-badge">
                                {{ school.palestinian_count }}
                            </span>
                            <span v-else class="text-muted">-</span>
                        </td>
                        
                        <td>
                             <span v-if="school.damg_count > 0" class="badge bg-warning text-dark print-badge">
                                {{ school.damg_count }}
                            </span>
                            <span v-else class="text-muted">-</span>
                        </td>
                    </tr>
                </tbody>
                
                <!-- الإجماليات -->
                <tfoot class="table-active fw-bold border-top-3">
                    <tr>
                        <td colspan="2" class="text-start pe-3 fs-5">جملة اللجنة</td>
                        <td class="fs-5 bg-dark text-white print-total">{{ committee.stats.total }}</td>
                        
                        <!-- إجمالي المنازل -->
                        <td class="fs-5 bg-secondary text-white print-grey">{{ committee.stats.manazel }}</td>
                        
                        <td>{{ committee.stats.muslim }}</td>
                        <td>{{ committee.stats.christian }}</td>
                        <td>{{ committee.stats.egyptian }}</td>
                        <td>{{ committee.stats.palestinian }}</td>
                        <td>{{ committee.stats.damg }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        
        <div class="page-break-inside-avoid"></div>

      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "CommitteeStatsReport",
  data() {
    return {
      loading: false,
      committees: []
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.get('/admin/committees/detailed-report');
        this.committees = res.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    printPage() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
.border-top-3 { border-top: 3px double #000 !important; }
.small-th { font-size: 0.85rem; }

@media print {
    @page { size: A4 portrait; margin: 10mm; }
    .no-print { display: none !important; }
    .d-print-block { display: block !important; }

    /* تمييز عمود المنازل باللون الرمادي في الطباعة */
    .print-grey {
        background-color: #6c757d !important;
        color: white !important;
        -webkit-print-color-adjust: exact;
    }

    .print-header-bg {
        background-color: #000 !important;
        color: #fff !important;
        -webkit-print-color-adjust: exact;
    }
    
    .print-total {
        background-color: #000 !important;
        color: #fff !important;
        -webkit-print-color-adjust: exact;
    }

    .print-badge {
        border: 1px solid #000;
        color: #000 !important;
        background: transparent !important;
    }

    .custom-table th, .custom-table td {
        border: 1px solid #000 !important;
        padding: 4px;
        font-size: 11pt; /* تصغير الخط قليلاً لاستيعاب الأعمدة */
    }

    .committee-block {
        page-break-inside: avoid;
        margin-bottom: 30px;
    }
}
</style>